import { cn } from '@/lib/utils';
import { Reveal, Eyebrow } from './shared';
import { FeaturedReviewsV2 } from './FeaturedReviewsV2';

const ITEMS = [
  { name: 'Hidratante Corporal (80g e 1kg)', num: '25351.406045/2024-11', dot: 'bg-v2-corpo' },
  { name: 'Hidratante para as Mãos', num: '25351.406032/2024-41', dot: 'bg-v2-maos' },
  { name: 'Hidratante para os Pés', num: '25351.406033/2024-96', dot: 'bg-v2-pes' },
  { name: 'Sabonete Líquido', num: '25351.406046/2024-65', dot: 'bg-v2-sab' },
  { name: 'Bálsamo Hidratante', num: '25351.408028/2024-18', dot: 'bg-v2-bal' },
];

export const TrustSection = () => (
  <section id="prova" className="scroll-mt-20 bg-v2-ink text-v2-bg py-16 md:py-24">
    <Reveal className="container mx-auto px-5 max-w-6xl">
      <Eyebrow className="text-v2-bg/70">Por que confiar</Eyebrow>
      <h2 className="font-narrow text-[2rem] leading-[1.05] md:text-5xl font-semibold tracking-tight max-w-2xl">
        Tudo o que está no rótulo, está aqui.
      </h2>
      <p className="mt-4 max-w-xl text-v2-bg/80">
        Cada produto tem número de processo na ANVISA, fabricante e responsável técnico impressos na embalagem. Sem segredo.
      </p>
      <ul className="mt-10 divide-y divide-v2-bg/10 border-y border-v2-bg/10">
        {ITEMS.map((i) => (
          <li key={i.num} className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 py-4">
            <span className="flex items-center gap-3">
              <span className={cn('w-2.5 h-2.5 rounded-full shrink-0', i.dot)} aria-hidden />
              {i.name}
            </span>
            <span className="font-mono text-base text-v2-bg/80 pl-5 sm:pl-0">{i.num}</span>
          </li>
        ))}
      </ul>
      <p className="mt-6 text-sm text-v2-bg/75">Fabricado por Florus Brasil, Indaiatuba (SP) · Aut. Func. 2.03522-0</p>
      <FeaturedReviewsV2 />
    </Reveal>
  </section>
);
